<template>
  <div>
    <div class="card vodset-card" v-if="vodset">
      <div class="card-content text-center">
        <div class="row d-flex align-items-center vodset-card-content">
          <div class="col-md-4">
            <div>
              <div class="icon-big text-center" :class="statusParams.icon">
                <i class="ti-blackboard"></i>
              </div>
              <span class="label" :class="statusParams.label">{{ statusParams.text }}</span>
            </div>
          </div>
          <div class="col-md-8">
            <div>
              <div>
                <h3>{{ vodset.name }}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <hr>
        <div v-if="vodset.status === 1">
          <div v-if="!vodset.processing" class="vodset-actions">
            <div class="footer-title">
              <button class="btn btn-default btn-fill btn-icon btn-sm" @click="$emit('move-set', {id: vodset.id, direction: 'up'})">
                <i class="ti-angle-up"></i>
              </button>
              <button class="btn btn-default btn-fill btn-icon btn-sm" @click="$emit('move-set', {id: vodset.id, direction: 'down'})">
                <i class="ti-angle-down"></i>
              </button>
            </div>
            <div class="pull-right">
              <button class="btn btn-danger btn-fill btn-icon btn-sm" @click="vodsetDeleteById(vodset.id)">
                Delete
              </button>
            </div>
          </div>
          <div v-else>
            <div>
              <em>VOD set is being processed</em>
            </div>
          </div>
        </div>
        <div v-else>
          <div>
            <strong>Processed date: </strong>
            <em>{{ vodset.updated_at }}</em>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  props: {
    vodset: {
      default: {
        name: 'testset.xml',
        status: 1
      }
    }
  },
  computed: {
    statusParams: function () {
      let status = this.vodset.status || 1;
      return this.statusMap[status];
    }
  },
  data: function () {
    return {
      statusMap: {
        1: {icon: 'icon-info', label: 'label-info', text: 'Pending'},
        2: {icon: 'icon-success', label: 'label-success', text: 'Processed'},
        3: {icon: 'icon-danger', label: 'label-danger', text: 'Error'},
      }
    }
  },
  methods: {
    ...mapActions(['vodsetDeleteById'])
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/VodSets/List/VodSetCard.vue